import { JsonObject } from '@bufbuild/protobuf';
import { FileShare } from '@q6cyber/proto2es/generated/fileshare';

import { FormControl, Validators } from '@angular/forms';

import { RouterOutput } from '../../../utils';
import { customFormGroup } from '../utilities';
import { DIGITS_ONLY_PATTERN } from '../validations/regex.validations';
import { CorruptedData } from './generic-data.interface';

export type SubscriptionClient =
  RouterOutput['clientSubscriptions']['listClientsBySubscription']['clients'][number];
export interface FileShareListResponse
  extends
    Omit<RouterOutput['fileShare']['list']['edges'][0], 'node'>,
    CorruptedData {
  node: FileShare | null;
}

export const DEFAULT_FILE_SHARE = new FileShare({
  uploadInfo: {},
}).toJson({
  emitDefaultValues: true,
}) as JsonObject;

export const fileShareForm = () => {
  const form = customFormGroup({
    file: new FormControl<File | null>(null, Validators.required),
    subscription: new FormControl<string | null>(null, Validators.required),
    clientName: new FormControl<string[]>([], {
      nonNullable: true,
      validators: Validators.required,
    }),
    uploadInfo: customFormGroup({
      notificationTitle: new FormControl<string>('', Validators.required),
      uploadedBy: new FormControl<string>('', Validators.email),
    }),
    filename: new FormControl<string>(''),
    exportMetricCount: new FormControl<number | null>(null, {
      validators: [
        Validators.required,
        Validators.min(1),
        Validators.pattern(DIGITS_ONLY_PATTERN),
      ],
    }),
    skipNotification: new FormControl<boolean>(false, { nonNullable: true }),
    addBanner: new FormControl<boolean>(false, { nonNullable: true }),
    expirationDate: new FormControl<string | null>(null),
    description: new FormControl<string>(''),
  });
  return form;
};
